function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui
import FormControlLabel from "@mui/material/FormControlLabel";
import MuiSwitch from "@mui/material/Switch";
// @limitless
import { useTranslation } from "@limitless/common/hooks";
const Switch = ({
  onLabel = "",
  checked = false,
  offLabel = "",
  onCheckedChanged,
  labelVariant = "body2",
  variantStyling = {},
  ...rest
}) => {
  const {
    id = `${onLabel.trim().toLowerCase() || "no_label"}_switch`
  } = {
    ...rest
  };
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(FormControlLabel, {
    id: `${id}-label`,
    control: /*#__PURE__*/React.createElement(MuiSwitch, _extends({
      checked: checked,
      onClick: onCheckedChanged
    }, rest, {
      sx: variantStyling,
      "aria-labelledby": `${id}-label`
    })),
    componentsProps: {
      typography: {
        variant: labelVariant
      }
    },
    label: checked ? t(onLabel) : t(offLabel)
  });
};
Switch.propTypes = {
  checked: PropTypes.bool,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  variantStyling: PropTypes.object,
  onCheckedChanged: PropTypes.func,
  labelVariant: PropTypes.string
};
export default Switch;